import { useState } from 'react';
import './UpdatePatentApplicationForm.css'
import { updatePatentApplication } from '../../utilities/api/patentApplications';


export default function UpdatePatentApplicationForm({user, patentApplication, updateApplication, toggleNotifications}) {
    const defaultState = {
        title: patentApplication.title||'',
        clientName: patentApplication.clientName||'',
        clientID: patentApplication.clientID||null,
        RPNumber: patentApplication.RPNumber||'',
        applicants: patentApplication.applicants||'',
        inventors: patentApplication.inventors||'',
        filingFirm: patentApplication.filingFirm||'',
        firmRefNumber: patentApplication.firmRefNumber||'',
        attorney: patentApplication.attorney||'',
        attorneyRefNumber: patentApplication.attorneyRefNumber||'',
        contact: patentApplication.contact||'',
        country: patentApplication.country||'',
        patentType: patentApplication.patentType||'',
        applicationType: patentApplication.applicationType||'',
        applicationStatus: patentApplication.applicationStatus||'',
        filingStatus: patentApplication.filingStatus||'',
        earliestPriorityDate: patentApplication.earliestPriorityDate||'',
        earliestPriorityApplicationNumber: patentApplication.earliestPriorityApplicationNumber||'',
        applicationNumber: patentApplication.applicationNumber||'',
        filingDate: patentApplication.filingDate||'',
        plannedFilingDate: patentApplication.plannedFilingDate||'',
        officialFilingDate: patentApplication.officialFilingDate||'',
        lastAction: patentApplication.lastAction||'',
        nextAction: patentApplication.nextAction||'',
        nextActionDueDate: patentApplication.nextActionDueDate||'',
        entityStatus: patentApplication.entityStatus||'',
        nationalEntryDate: patentApplication.nationalEntryDate||'',
        publicationDate: patentApplication.publicationDate||'',
        estimatedFirstOfficeActionDate: patentApplication.estimatedFirstOfficeActionDate||'',
        officialOfficeActionDate: patentApplication.officialOfficeActionDate||'',
        allowanceDate: patentApplication.allowanceDate||'',
        requestExaminerInterview: patentApplication.requestExaminerInterview||'',
        examinerInterviewDate: patentApplication.examinerInterviewDate||'',
        filedRCE: patentApplication.filedRCE||'',
        RCEFiledDate: patentApplication.RCEFiledDate||'',
        issueFeePaymentDate: patentApplication.issueFeePaymentDate||'',
        issueDate: patentApplication.issueDate||'',
        patentNumber: patentApplication.patentNumber||'',
        maintenanceFeeDueDate: patentApplication.maintenanceFeeDueDate||'',
        maintenanceFeeStatus: patentApplication.maintenanceFeeStatus||'',
        expirationDate: patentApplication.expirationDate||'',
        abandonedDate: patentApplication.abandonedDate||'',
        PAIRReg: patentApplication.PAIRReg||'',
        notes: patentApplication.notes||'',
        driveFolderLocation: patentApplication.driveFolderLocation||'',
    }
    const [formData, setFormData] = useState(defaultState)
    const rpNumberReg = /^([A-Z]{2}-[0-9]{4}\.[0-9]{2,}\.[0-9]{3}.*)$/
    const [isValidRPNumber, setIsValidRPNumber] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (evt) =>{
        evt.preventDefault();
        setIsSubmitting(true)
        try {
            const updatedPatentApplication = await updatePatentApplication(patentApplication._id, formData)
            updateApplication(updatedPatentApplication)
            await toggleNotifications('success', `Patent Application "${patentApplication.applicationNumber}" Successfully Updated!`, '#FFFFFF')
        } catch (error) {
            console.log(error)
            await toggleNotifications('error', `Failed to Update Patent Application "${patentApplication.applicationNumber}"!`, '#FFFFFF')
        }
        setIsSubmitting(false)
    }

    const populateDates = async (formData) => {
        try {
            if (formData.applicationType === 'provisional' && formData.filingDate) {
                const filingDate = new Date(formData.filingDate)
                const expirationDate = new Date(filingDate)
                expirationDate.setFullYear(expirationDate.getFullYear() + 1)
                setFormData(prevFormData => ({
                    ...prevFormData,
                    expirationDate: expirationDate.toISOString().split('T')[0]
                }))
            } else if (formData.applicationType === 'canadian' && formData.filingDate) {
                const filingDate = new Date(formData.filingDate)
                const maintenanceFeeDueDate = new Date(filingDate)
                maintenanceFeeDueDate.setFullYear(maintenanceFeeDueDate.getFullYear() + 2)
                setFormData(prevFormData => ({
                    ...prevFormData,
                    maintenanceFeeDueDate: maintenanceFeeDueDate.toISOString().split('T')[0]
                }))
            } else if (formData.applicationType === 'PCT' && formData.filingDate) {
                const filingDate = new Date(formData.filingDate)
                const expirationDate = new Date(filingDate)
                const years = Math.floor(30 / 12)
                const months = 30 % 12
                expirationDate.setFullYear(expirationDate.getFullYear() + years)
                expirationDate.setMonth(expirationDate.getMonth() + months)
                setFormData(prevFormData => ({
                    ...prevFormData,
                    expirationDate: expirationDate.toISOString().split('T')[0]
                }))
            }
        } catch (error) {
            console.log(error)
        }
    }

    async function handleChange(evt) {
        const newFormData = {
          ...formData,
          [evt.target.name]: evt.target.value,
        }

        if (evt.target.name === 'RPNumber') {
            await checkRPNumber(evt)
        }

        if (evt.target.name === 'applicationType') {
            // Clear auto-populated fields when application type changes
            newFormData.expirationDate = ''
            newFormData.maintenanceFeeDueDate = ''
        }

        setFormData(newFormData);

        if (evt.target.name === 'applicationType' || evt.target.name === 'filingDate') {
            await populateDates(newFormData)
        }
    }

    const checkRPNumber = async (evt) => {
        const rpNumber = evt.target.value
        rpNumberReg.test(rpNumber) ? setIsValidRPNumber(true) : setIsValidRPNumber(false)
    }


    const disabled = !formData.title || !formData.clientID || !formData.clientName || !formData.RPNumber || !isValidRPNumber || !formData.applicationNumber || !formData.filingDate
  return (
    <div className='UpdatePatentApplicationForm'>
        <form onSubmit={handleSubmit} id={`updatePatentApplicationForm-${patentApplication._id}`}>
            <div className='formContent'>
                <div className='form-group'>
                    <label htmlFor={`title${patentApplication._id}`} className='form-label'>Title <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`title${patentApplication._id}`} name='title' className='form-control' value={formData.title} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`clientName${patentApplication._id}`} className='form-label'>Client Name<span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`clientName${patentApplication._id}`} name='clientName' className='form-control' value={formData.clientName} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`clientID${patentApplication._id}`} className='form-label'>Client ID <span className='requiredField'><strong>*</strong></span></label>
                    <input type="number" min={0} id={`clientID${patentApplication._id}`} name='clientID' className='form-control' value={formData.clientID} onChange={handleChange}/>
                </div>
                <div className='form-group rpNumber'>
                    <div className='input'>
                        <label htmlFor={`RPNumber${patentApplication._id}`} className='form-label'>RP Number <span className='requiredField'><strong>*</strong></span></label>
                        <input type="text" id={`RPNumber${patentApplication._id}`} name='RPNumber' className='form-control' value={formData.RPNumber} onChange={handleChange}/>
                    </div>
                    <div className='rpNumberStatus'>
                        <small className="form-text checkIsValidRPNumber" style={{backgroundColor:`${isValidRPNumber? 'green' : 'red'}`, color:'white'}}>Format: XX-0000.00.000</small>
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicants${patentApplication._id}`} className='form-label'>Applicants</label>
                    <input type="text" id={`applicants${patentApplication._id}`} name='applicants' className='form-control' value={formData.applicants} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`inventors${patentApplication._id}`} className='form-label'>Inventors</label>
                    <input type="text" id={`inventors${patentApplication._id}`} name='inventors' className='form-control' value={formData.inventors} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filingFirm${patentApplication._id}`} className='form-label'>Filing Firm</label>
                    <input type="text" id={`filingFirm${patentApplication._id}`} name='filingFirm' className='form-control' value={formData.filingFirm} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`firmRefNumber${patentApplication._id}`} className='form-label'>Firm Ref Number</label>
                    <input type="text" id={`firmRefNumber${patentApplication._id}`} name='firmRefNumber' className='form-control' value={formData.firmRefNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`attorney${patentApplication._id}`} className='form-label'>Attorney</label>
                    <input type="text" id={`attorney${patentApplication._id}`} name='attorney' className='form-control' value={formData.attorney} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`attorneyRefNumber${patentApplication._id}`} className='form-label'>Attorney Ref Number</label>
                    <input type="text" id={`attorneyRefNumber${patentApplication._id}`} name='attorneyRefNumber' className='form-control' value={formData.attorneyRefNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`contact${patentApplication._id}`} className='form-label'>Contact</label>
                    <input type="text" id={`contact${patentApplication._id}`} name='contact' className='form-control' value={formData.contact} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`country${patentApplication._id}`} className='form-label'>Country</label>
                    <input type="text" id={`country${patentApplication._id}`} name='country' className='form-control' value={formData.country} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`patentType${patentApplication._id}`} className='form-label'>Patent Type</label>
                    <select id={`patentType${patentApplication._id}`} name='patentType' className='form-select' value={formData.patentType} onChange={handleChange}>
                        <option value="">---Select Patent Type---</option>
                        <option value="utility">Utility</option>
                        <option value="design">Design</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationType${patentApplication._id}`} className='form-label'>Application Type</label>
                    <select id={`applicationType${patentApplication._id}`} name='applicationType' className='form-select' value={formData.applicationType} onChange={handleChange}>
                        <option value="">---Select Application Type---</option>
                        <option value="provisional">Provisional</option>
                        <option value="nonProvisional">Non-Provisional</option>
                        <option value="PCT">PCT</option>
                        <option value="canadian">Canadian</option>
                        <option value="foreign">Foreign</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationStatus${patentApplication._id}`} className='form-label'>Application Status</label>
                    <select id={`applicationStatus${patentApplication._id}`} name='applicationStatus' className='form-select' value={formData.applicationStatus} onChange={handleChange}>
                        <option className='empty' value="">---Select Application Status---</option>
                        <option value="abandoned">Abandoned</option>
                        <option value="allowed">Allowed</option>
                        <option value="approved">Approved</option>
                        <option value="awaitingExam">Awaiting Exam</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="expired">Expired</option>
                        <option value="filed">Filed</option>
                        <option value="granted">Granted</option>
                        <option value="NOAIssued">NOA Issued</option>
                        <option value="officeActionIssued">Office Action Issued</option>
                        <option value="published">Published</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`earliestPriorityDate${patentApplication._id}`} className='form-label'>Earliest Priority Date</label>
                    <input type="date" id={`earliestPriorityDate${patentApplication._id}`} name='earliestPriorityDate' className='form-control' value={formData.earliestPriorityDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`earliestPriorityApplicationNumber${patentApplication._id}`} className='form-label'>Earliest Priority Application Number</label>
                    <input type="text" id={`earliestPriorityApplicationNumber${patentApplication._id}`} name='earliestPriorityApplicationNumber' className='form-control' value={formData.earliestPriorityApplicationNumber}  onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`lastAction${patentApplication._id}`} className='form-label'>Last Action</label>
                    <input type="text" id={`lastAction${patentApplication._id}`} name='lastAction' className='form-control' value={formData.lastAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nextAction${patentApplication._id}`} className='form-label'>Next Action</label>
                    <input type="text" id={`nextAction${patentApplication._id}`} name='nextAction' className='form-control' value={formData.nextAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nextActionDueDate${patentApplication._id}`} className='form-label'>Next Action Due</label>
                    <input type="date" id={`nextActionDueDate${patentApplication._id}`} name='nextActionDueDate' className='form-control' value={formData.nextActionDueDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`entityStatus${patentApplication._id}`} className='form-label'>Entity Status</label>
                    <select id={`entityStatus${patentApplication._id}`} name='entityStatus' className='form-select' value={formData.entityStatus} onChange={handleChange}>
                        <option value="">---Select Application Type---</option>
                        <option value="micro">Micro</option>
                        <option value="small">Small</option>
                        <option value="large">Large</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationNumber${patentApplication._id}`} className='form-label'>Application Number <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`applicationNumber${patentApplication._id}`} name='applicationNumber' className='form-control' value={formData.applicationNumber}  onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filingDate${patentApplication._id}`} className='form-label'>Filing Date <span className='requiredField'><strong>*</strong></span></label>
                    <input type="date" id={`filingDate${patentApplication._id}`} name='filingDate' className='form-control' value={formData.filingDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`plannedFilingDate${patentApplication._id}`} className='form-label'>Planned Filing Date</label>
                    <input type="date" id={`plannedFilingDate${patentApplication._id}`} name='plannedFilingDate' className='form-control' value={formData.plannedFilingDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`officialFilingDate${patentApplication._id}`} className='form-label'>Official Filing Date</label>
                    <input type="date" id={`officialFilingDate${patentApplication._id}`} name='officialFilingDate' className='form-control' value={formData.officialFilingDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nationalEntryDate${patentApplication._id}`} className='form-label'>National Entry Date</label>
                    <input type="date" id={`nationalEntryDate${patentApplication._id}`} name='nationalEntryDate' className='form-control' value={formData.nationalEntryDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`publicationDate${patentApplication._id}`} className='form-label'>Publication Date</label>
                    <input type="date" id={`publicationDate${patentApplication._id}`} name='publicationDate' className='form-control' value={formData.publicationDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`estimatedFirstOfficeActionDate${patentApplication._id}`} className='form-label'>Estimated First Office Action Date</label>
                    <input type="date" id={`estimatedFirstOfficeActionDate${patentApplication._id}`} name='estimatedFirstOfficeActionDate' className='form-control' value={formData.estimatedFirstOfficeActionDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`officialOfficeActionDate${patentApplication._id}`} className='form-label'>Official Office Action Date</label>
                    <input type="date" id={`officialOfficeActionDate${patentApplication._id}`} name='officialOfficeActionDate' className='form-control' value={formData.officialOfficeActionDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`allowanceDate${patentApplication._id}`} className='form-label'>Allowance Date</label>
                    <input type="date" id={`allowanceDate${patentApplication._id}`} name='allowanceDate' className='form-control' value={formData.allowanceDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`requestExaminerInterview${patentApplication._id}`} className='form-label'>Request Examiner Interview</label>
                    <select id={`requestExaminerInterview${patentApplication._id}`} name='requestExaminerInterview' className='form-select' value={formData.requestExaminerInterview} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`examinerInterviewDate${patentApplication._id}`} className='form-label'>Examiner Interview Date</label>
                    <input type="date" id={`examinerInterviewDate${patentApplication._id}`} name='examinerInterviewDate' className='form-control' value={formData.examinerInterviewDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filedRCE${patentApplication._id}`} className='form-label'>Filed RCE</label>
                    <select id={`filedRCE${patentApplication._id}`} name='filedRCE' className='form-select' value={formData.filedRCE} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`RCEFiledDate${patentApplication._id}`} className='form-label'>RCE Filing Date</label>
                    <input type="date" id={`RCEFiledDate${patentApplication._id}`} name='RCEFiledDate' className='form-control' value={formData.RCEFiledDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`issueFeePaymentDate${patentApplication._id}`} className='form-label'>Issue Fee Payment Date</label>
                    <input type="date" id={`issueFeePaymentDate${patentApplication._id}`} name='issueFeePaymentDate' className='form-control' value={formData.issueFeePaymentDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`issueDate${patentApplication._id}`} className='form-label'>Issue Fee Payment Date</label>
                    <input type="date" id={`issueDate${patentApplication._id}`} name='issueDate' className='form-control' value={formData.issueDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`patentNumber${patentApplication._id}`} className='form-label'>Patent Number</label>
                    <input type="text" id={`patentNumber${patentApplication._id}`} name='patentNumber' className='form-control' value={formData.patentNumber}  onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`maintenanceFeeDueDate${patentApplication._id}`} className='form-label'>Maintenance Fee Date</label>
                    <input type="date" id={`maintenanceFeeDueDate${patentApplication._id}`} name='maintenanceFeeDueDate' className='form-control' value={formData.maintenanceFeeDueDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`maintenanceFeeStatus${patentApplication._id}`} className='form-label'>Maintenance Fee Status</label>
                    <select id={`maintenanceFeeStatus${patentApplication._id}`} name='maintenanceFeeStatus' className='form-select' value={formData.maintenanceFeeStatus} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="paid">Paid</option>
                        <option value="unpaid">Unpaid</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`expirationDate${patentApplication._id}`} className='form-label'>Expiration Date</label>
                    <input type="date" id={`expirationDate${patentApplication._id}`} name='expirationDate' className='form-control' value={formData.expirationDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`abandonedDate${patentApplication._id}`} className='form-label'>Abandoned Date</label>
                    <input type="date" id={`abandonedDate${patentApplication._id}`} name='abandonedDate' className='form-control' value={formData.abandonedDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`PAIRReg${patentApplication._id}`} className='form-label'>PAIR Reg</label>
                    <input type="text" id={`PAIRReg${patentApplication._id}`} name='PAIRReg' className='form-control' value={formData.PAIRReg} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`notes${patentApplication._id}`} className='form-label'>Notes</label>
                    <textarea id={`notes${patentApplication._id}`} name='notes' className='form-control' value={formData.notes} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`driveFolderLocation${patentApplication._id}`} className='form-label'>Folder Location</label>
                    <input type="text" id={`driveFolderLocation${patentApplication._id}`} name='driveFolderLocation' className='form-control' value={formData.driveFolderLocation} onChange={handleChange}/>
                </div>
            </div>
        </form>
        <div className='formButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>
                Cancel
            </button>
            <button data-bs-dismiss="modal" className="submit" type="submit" form={`updatePatentApplicationForm-${patentApplication._id}`} disabled={disabled||isSubmitting}>
                Update Application
            </button>
        </div>
    </div>
  )
}
